<template>
  <div class="overlay">
    <div class="overlay__wrapper">
      <div class="overlay__content">
        <ul
          id="modal-content"
          class="modal__content-list modal__content-list--preview"
        >
          <li class="modal__content-item modal__content-item--title">
            <!--<span :class="{'modal__title': true, 'modal__title--preview-success':this.previewstatus === 'success'}" v-html="this.config.lang['modal.control.preview-header-' + this.previewstatus]"></span>
                        <span v-if="this.modalmodifier === 'success'" class="modal__title modal__title--preview-success" v-html="this.config.lang['modal.control.preview-header-success']"></span>
                        <span v-if="this.modalmodifier === 'errorua'" class="modal__title modal__title--preview-warning" v-html="this.config.lang['modal.control.preview-header-errorua']"></span>
                        <span v-if="this.modalmodifier === 'errorba'" class="modal__title modal__title--preview-warning" v-html="this.config.lang['modal.control.preview-header-errorba']"></span>
                        <span v-if="this.modalmodifier === 'erroruaba'" class="modal__title modal__title--preview-warning" v-html="this.config.lang['modal.control.preview-header-erroruaba']"></span>-->
            <span
              class="modal__title modal__title--preview-success"
              v-html="
                this.config.lang[
                  'modal.control.preview-header-' + this.previewstatus
                ]
              "
            ></span>
            <span class="modal__close" @click="jobPreviewClose"></span>
          </li>
          <li class="modal__content-item modal__content-item--preview">
            <div v-if="this.modalmodifier === 'errorua'">
              <h3
                class="modal__content-preview-subheader"
                v-html="
                  this.config.lang['modal.control.preview-subheader-errorua']
                "
              ></h3>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.errorua.par1']
                "
              ></p>
              <p
                class="text--content-preview text--content-bold text--content-line"
                v-html="
                  this.config.lang['modal.control.preview-text.errorua.par2']
                "
              ></p>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.errorua.par3']
                "
              ></p>
              <p
                class="text--content-preview text--content-bold text--content-line"
                v-html="
                  this.config.lang['modal.control.preview-text.errorua.par4']
                "
              ></p>
              <p
                class="text--content-preview text--content-line"
                v-html="
                  this.config.lang['modal.control.preview-text.errorua.par5']
                "
              ></p>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.errorua.par6']
                "
              ></p>
            </div>
            <div v-if="this.modalmodifier === 'errorba'">
              <h3
                class="modal__content-preview-subheader"
                v-html="
                  this.config.lang['modal.control.preview-subheader-errorba']
                "
              ></h3>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.errorba.par1']
                "
              ></p>
              <p
                class="text--content-preview text--content-bold text--content-line"
                v-html="
                  this.config.lang['modal.control.preview-text.errorba.par2']
                "
              ></p>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.errorba.par3']
                "
              ></p>
              <p
                class="text--content-preview text--content-bold text--content-line"
                v-html="
                  this.config.lang['modal.control.preview-text.errorba.par4']
                "
              ></p>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.errorba.par5']
                "
              ></p>
            </div>
            <div v-if="this.modalmodifier === 'erroruaba'">
              <h3
                class="modal__content-preview-subheader"
                v-html="
                  this.config.lang['modal.control.preview-subheader-erroruaba']
                "
              ></h3>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.erroruaba.par1']
                "
              ></p>
              <p
                class="text--content-preview text--content-bold text--content-line"
                v-html="
                  this.config.lang['modal.control.preview-text.erroruaba.par2']
                "
              ></p>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.erroruaba.par3']
                "
              ></p>
              <p
                class="text--content-preview text--content-bold text--content-line"
                v-html="
                  this.config.lang['modal.control.preview-text.erroruaba.par4']
                "
              ></p>
              <p
                class="text--content-preview"
                v-html="
                  this.config.lang['modal.control.preview-text.erroruaba.par5']
                "
              ></p>
            </div>
            <div class="preview__container">
              <div class="preview__slide_container">
                <div class="preview__slide">
                  <img
                    :src="imagesource"
                    class="preview__image"
                    alt="Vorschaubild"
                  />
                </div>
              </div>
              <p
                v-if="!errorUnreadableAdress && !errorBarcodeArea"
                class="modal__preview-info"
              >
                {{ this.config.lang["modal.control.preview-note"] }}
              </p>
            </div>
            <div class="modal__control_action">
              <div
                v-if="errorUnreadableAdress || errorBarcodeArea"
                class="modal__control_actionwrapper"
              >
                <p
                  v-if="errorBarcodeArea"
                  class="modal__control_actionwrapper modal__control_actionwrapper--barcodefixing js-barcode-fixing"
                >
                  <label
                    for="barcodeFixing"
                    class="form__pincheckbox form__pincheckbox--pointer form__pincheckbox--barcodefixing"
                  >
                    <input
                      class="form__pincheckbox-input"
                      type="checkbox"
                      id="barcodeFixing"
                      name="barcodeFixing"
                      value="1"
                      v-model="removeBarcode"
                    />
                    <span class="form__pincheckbox-border"></span>
                    <span class="form__pincheckbox-label">
                      {{
                        this.config.lang[
                          "modal.control.preview-deactivate-barcode"
                        ]
                      }}
                    </span>
                  </label>
                </p>
                <button
                  :disabled="
                    this.modalmodifier === 'errorba' && !this.removeBarcode
                  "
                  class="form__button form__button-greenandarrow modal__control_submit modal__accept_action modal__accept_action--desktop"
                  @click="jobPreviewAccept"
                >
                  {{ this.config.lang["modal.control.preview-accept"] }}
                </button>
                <button
                  :disabled="
                    this.modalmodifier === 'errorba' && !this.removeBarcode
                  "
                  class="form__button form__button-greenandarrow modal__control_submit modal__accept_action modal__accept_action--mobile"
                  @click="jobPreviewAccept"
                >
                  {{ this.config.lang["modal.control.preview-accept-mobile"] }}
                </button>
                <span
                  class="modal__control_cancel modal-close-action modal__error-button modal__delete_action delete__from--warning"
                  @click="jobPreviewDelete"
                >
                  {{ this.config.lang["modal.control.preview-delete"] }}
                </span>
              </div>
              <p class="modal__control_actionwrapper">
                <a
                  href="javascript:void(0);"
                  class="modal__control_cancel modal-close-action"
                  @click="jobPreviewClose"
                >
                  {{ this.config.lang["modal.control.action-cancel"] }}
                </a>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import ImageService from "../services/ImageService";
import JobService from "../services/JobService";

export default {
  name: "JobAccept",
  props: {
    configdata: {
      type: Object,
      default: () => ({})
    },
    jobpid: {
      type: String,
      default: () => undefined
    },
    documents: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    jobpid: function(jobpid) {
      console.log(jobpid);
      console.log(this.$parent.jobs);
      if (typeof jobpid !== "undefined") {
        console.log(this.$parent.jobs[jobpid]);
        if (this.$parent.jobs.hasOwnProperty(jobpid)) {
          console.log("set current job");
          this.currentjob = this.$parent.jobs[jobpid];
          this.previewstatus =
            this.currentjob.frontendstatus === "success"
              ? "success"
              : "warning";
          this.getPreviewImage();
        } else {
          this.currentjob = undefined;
          console.error("Unknown jobpid in EditControl.");
        }
      } else {
        this.currentjob = undefined;
      }
    }
  },
  data() {
    return {
      currentjob: undefined,
      previewstatus: undefined,
      //defaultMessages: [],
      //barcodeMessages: [],
      imagesource: undefined,
      errorUnreadableAdress: false,
      errorBarcodeArea: false,
      removeBarcode: false
    };
  },
  computed: {
    config: function() {
      return configdata;
    },
    modalmodifier: function() {
      // error unreadable adress
      if (this.errorUnreadableAdress && !this.errorBarcodeArea) {
        return "errorua";
      }
      // error barcodearea
      if (!this.errorUnreadableAdress && this.errorBarcodeArea) {
        return "errorba";
      }
      // error unreadable adress and error barcodearea
      if (this.errorUnreadableAdress && this.errorBarcodeArea) {
        return "erroruaba";
      }
      return "success";
    }
  },
  methods: {
    getPreviewImage() {
      let preview = {
        jobId: this.currentjob.id
      };
      ImageService.getPreviewImage(
        this.config.routes["ebrief_job_preview"],
        preview
      ).then(response => {
        console.log("-------------------------------------");
        console.log("ImageService.getPreviewImage:");
        console.log(response);
        console.log("-------------------------------------");
        if (response.preview.success) {
          //this.defaultMessages = response.preview.messages.default;
          //this.barcodeMessages = response.preview.messages.barcode;
          this.errorUnreadableAdress = response.preview.errorUnreadableAdress;
          this.errorBarcodeArea = response.preview.errorBarcodeArea;
          this.imagesource = response.preview.source;
          this.$emit("preview-loaded");
        } else {
          let message = {
            header: this.config.lang[
              "ebrief.error.preview_not_available.header"
            ],
            text: this.config.lang["ebrief.error.preview_not_available.text"]
          };
          this.$emit("show-error", message);
        }
      });
    },
    jobPreviewAccept() {
      let job = this.currentjob;
      this.$emit("preview-job-close");
      this.$emit("show-spinner-modal");
      let data = {
        jobId: job.id,
        removeBarcode: this.removeBarcode
      };

      // if remove barcode is false disable the button
      console.log(data);
      JobService.acceptJobFromPreview(
        this.config.routes["ebrief_accept_job_documents"],
        data
      ).then(response => {
        let error = false;
        if (response.success) {
          this.$set(job, "frontendstatus", "in-process");
          this.$set(job, "jobInfo", this.config.statuslang["in-process"]);
          this.$set(job, "shipmentType", "ST");
          this.$set(job, "shipmenttypemodifier", "st");
        } else {
          error = {
            header: response.error.header,
            text: response.error.text
          };
        }
        this.removeBarcode = false;
        this.$emit("preview-job-accept", error);
      });
    },
    jobPreviewDelete() {
      this.removeBarcode = false;
      this.$emit("preview-job-delete", this.currentjob.pid);
    },
    jobPreviewClose() {
      this.removeBarcode = false;
      this.$emit("preview-job-close");
    }
  }
};
</script>
